//
// This form is currently used on a legacy page, so
// legacy apollo client is currently being used.
//

import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";

import SubscriptionLinks from "./SubscriptionLinks";
import InvoiceInformation from "./InvoiceInformation";
import PrepaidBalance from "./PrepaidBalance";
import StripePortalElement from "./StripePortalElement";

import { apolloClient } from "js/apollo/apollo-client";
import {
    GET_CURRENT_USER_WITH_BILLING,
    GET_SAVED_CARD,
    GET_SUBSCRIPTION
} from "./queries";

const BillingForm = ({
    args: { subUsername, isTeamPage, team } // from Django template: accounts/settings_plan.html
}) => {
    const handlingTeam = isTeamPage && !!team;
    const { data: userData } = useQuery(GET_CURRENT_USER_WITH_BILLING, {
        client: apolloClient,
        fetchPolicy: "network-only"
    });

    const user = userData && userData.currentUser;

    const organizationId = handlingTeam ? team.id : null;
    const { data: stripeData } = useQuery(GET_SAVED_CARD, {
        client: apolloClient,
        fetchPolicy: "network-only",
        variables: {
            organizationId
        }
    });
    const stripe = stripeData && stripeData.savedCard;

    const { data: subscriptionData } = useQuery(GET_SUBSCRIPTION, {
        client: apolloClient,
        fetchPolicy: "network-only",
        variables: {
            username: subUsername
        }
    });
    const subscription = subscriptionData?.getSubscription;

    if (!user) {
        return null;
    }

    const {
        email,
        csrf,
        hasPrepaidBalance = false,
        totalPrepaidBalanceAvailableCents
    } = user;

    const hasSavedCard = !!(stripe && stripe.id);
    const hasPaypal = !!subscription?.paypalId;
    const billingInfo =
        stripe && stripe.receiptInfo ? stripe.receiptInfo : null;
    const canSaveVAT = hasSavedCard || hasPaypal || !!billingInfo;

    const showPrepaidBalance = hasPrepaidBalance && !isTeamPage;

    return (
        <div>
            {showPrepaidBalance && (
                <PrepaidBalance
                    totalPrepaidBalanceAvailableCents={
                        totalPrepaidBalanceAvailableCents
                    }
                />
            )}
            <StripePortalElement organizationId={organizationId} />
            {subscription && (
                <SubscriptionLinks
                    activeUsername={subUsername}
                    email={email}
                    csrf={csrf}
                    {...subscription}
                />
            )}
            <InvoiceInformation
                canSaveVAT={canSaveVAT}
                billingInfo={billingInfo}
                organizationId={organizationId}
            />
        </div>
    );
};

BillingForm.propTypes = {
    args: PropTypes.object.isRequired
};

export default BillingForm;
